// Mirrors backend/backend3/src/utils/egyptPhone.ts's classifyEgyptianPhone,
// so the frontend rejects a number before submit instead of round-tripping
// to get the API's callcenter_invalid_phone error.
const MOBILE_REGEX = /^01[0125]\d{8}$/; // 11 digits, prefixes 010/011/012/015
const LANDLINE_REGEX = /^0[2-9]\d{6,8}$/; // area code + 7-9 digits (e.g. Cairo 02, other governorates)

export function classifyEgyptianPhone(raw) {
  const digitsOnly = String(raw ?? "").replace(/[^\d]/g, "");

  let normalized = digitsOnly;
  if (normalized.startsWith("0020")) {
    normalized = normalized.slice(4);
  } else if (normalized.startsWith("20") && normalized.length > 10) {
    normalized = normalized.slice(2);
  }
  if (!normalized.startsWith("0")) {
    normalized = `0${normalized}`;
  }

  if (MOBILE_REGEX.test(normalized)) return "mobile";
  if (LANDLINE_REGEX.test(normalized)) return "landline";
  return "invalid";
}

export const isValidEgyptianPhone = (raw) =>
  !!raw && classifyEgyptianPhone(raw) !== "invalid";

// ServiceRequest.description has no explicit @db.VarChar in schema.prisma, so
// Prisma's MySQL default of varchar(191) is the real, enforced backend limit.
export const COMPLAINT_DESCRIPTION_MAX_LENGTH = 191;

export const MAX_SECONDARY_PHONES = 10;
